import ProceduresBridge from './ProceduresBridge';
import angular, { ITemplateCacheService } from 'angular';

const proceduresModule = angular
  .module('flowingly.runner.procedures', [])
  .component('procedures', ProceduresBridge);

proceduresModule.run([
  '$templateCache',
  ($templateCache: ITemplateCacheService) => {
    $templateCache.put(
      'Client/runner.procedures/runner.procedure.tmpl.html',
      require('./runner.procedure.tmpl.html').default
    );
  }
]);
export default proceduresModule;
